<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import TaskSortMenu from './components/TaskSortMenu.vue';
import TaskFilterBar from './components/TaskFilterBar.vue';

defineProps({
  headerTitle: { type: String, required: true },
  openCount: { type: Number, default: 0 },
  overdueCount: { type: Number, default: 0 },
  activeSort: { type: String, default: 'due_at' },
  activeOrdering: { type: String, default: '' },
  viewMode: { type: String, default: 'list' },
  filters: { type: Object, default: () => ({}) },
});

const emit = defineEmits([
  'update:sort',
  'update:viewMode',
  'apply-filters',
  'clear-filters',
  'create-task',
]);

const { t } = useI18n();
</script>

<template>
  <header class="sticky top-0 z-10 bg-n-solid-2 border-b border-n-weak">
    <div
      class="flex items-start sm:items-center justify-between w-full py-4 px-6 gap-2"
    >
      <div class="flex items-baseline gap-3 min-w-0">
        <span class="text-xl font-medium truncate text-n-slate-12">
          {{ headerTitle }}
        </span>
        <span class="text-sm text-n-slate-10 truncate">
          {{
            t('TASKS_DASHBOARD.HEADER_SUBTITLE', {
              openCount,
              overdueCount,
            })
          }}
        </span>
      </div>
      <div class="flex items-center flex-row flex-shrink-0 gap-2">
        <div
          class="flex items-center rounded-lg bg-n-alpha-2 p-0.5 gap-0.5 mr-1"
        >
          <Button
            :label="t('TASKS_DASHBOARD.VIEW.LIST')"
            size="xs"
            :variant="viewMode === 'list' ? 'solid' : 'ghost'"
            :color="viewMode === 'list' ? 'blue' : 'slate'"
            @click="emit('update:viewMode', 'list')"
          />
          <Button
            :label="t('TASKS_DASHBOARD.VIEW.KANBAN')"
            size="xs"
            :variant="viewMode === 'kanban' ? 'solid' : 'ghost'"
            :color="viewMode === 'kanban' ? 'blue' : 'slate'"
            @click="emit('update:viewMode', 'kanban')"
          />
        </div>
        <TaskFilterBar
          :filters="filters"
          @apply="emit('apply-filters', $event)"
          @clear="emit('clear-filters')"
        />
        <TaskSortMenu
          :active-sort="activeSort"
          :active-ordering="activeOrdering"
          @update:sort="emit('update:sort', $event)"
        />
        <Button
          icon="i-lucide-plus"
          size="sm"
          :label="t('TASKS_DASHBOARD.NEW_TASK')"
          @click="emit('create-task')"
        />
      </div>
    </div>
  </header>
</template>
